module.exports = __webpack_public_path__ + "img/banner_left.cfa6a986.jpg";